// extracted by mini-css-extract-plugin
var _1 = "ActionsHeader_iconTableSettingsButton__EJhH-";
var _2 = "ActionsHeader_tableSettingsButton__a+mGR";
export { _1 as "iconTableSettingsButton", _2 as "tableSettingsButton" }
